import { memo, ReactElement } from 'react';
import { styled } from 'styled-components';
import { Form, Input, Select, DatePicker, AutoComplete } from 'antd';
import { blockStyle } from '../../../../../components/styles/Block';
import layoutStyle from '../../../../../components/styles/Layout';
import { PHONE_SEARCH_PATTERN } from '../../../../../shared/phonePattern';

const { RangePicker } = DatePicker;

interface Props {
  customerOptions: { value: string }[];
  advisorOptions: { value: string }[];
}

const Block = styled.div`
  ${blockStyle}
  display: flex;
`;

const Layout = styled.div`
  ${layoutStyle}
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const FieldBlock = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 200px;
`;

const statusOptions = [
  { value: 1, label: '処理中' },
  { value: 2, label: '完了' },
  { value: 3, label: '失敗' },
];

const filterOption = (inputValue: string, option?: { value: string }): boolean =>
  option?.value.toLowerCase().includes(inputValue.toLowerCase()) ?? false;

// 電話番号検索の入力バリデーション（任意入力・空欄可、入力時は 1〜11 桁の数字のみ）
const phoneSearchRule = {
  validator: (_: unknown, value: string | undefined) => {
    if (!value || value === '') {
      return Promise.resolve();
    }
    if (PHONE_SEARCH_PATTERN.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('11桁以内の数字で入力してください'));
  },
};

const FormRow = memo(
  ({ customerOptions, advisorOptions }: Props): ReactElement => (
    <Block>
      <Layout>
        <FieldBlock>
          <Form.Item name='customerName' label='顧客名で検索' layout='vertical'>
            <AutoComplete
              placeholder='顧客名を入力または選択...'
              options={customerOptions}
              filterOption={filterOption}
              defaultActiveFirstOption={false}
              backfill={false}
              allowClear
            />
          </Form.Item>
        </FieldBlock>
        <FieldBlock>
          <Form.Item name='customerPhone' label='顧客電話番号で検索' layout='vertical' rules={[phoneSearchRule]}>
            <Input placeholder='09012345678' allowClear />
          </Form.Item>
        </FieldBlock>
        <FieldBlock>
          <Form.Item name='advisorName' label='担当者名で検索' layout='vertical'>
            <AutoComplete
              placeholder='担当者名を入力または選択...'
              options={advisorOptions}
              filterOption={filterOption}
              defaultActiveFirstOption={false}
              backfill={false}
              allowClear
            />
          </Form.Item>
        </FieldBlock>
        <FieldBlock>
          <Form.Item name='recordingStatusId' label='処理状態で絞り込み' layout='vertical'>
            <Select placeholder='全ての状態' allowClear options={statusOptions} />
          </Form.Item>
        </FieldBlock>
        <FieldBlock>
          <Form.Item name='dateRange' label='日付範囲' layout='vertical'>
            <RangePicker format='YYYY-MM-DD' placeholder={['開始日', '終了日']} />
          </Form.Item>
        </FieldBlock>
      </Layout>
    </Block>
  )
);

FormRow.displayName = 'FormRow';

export default FormRow;
